import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, Maximize2, BedDouble, Bath } from "lucide-react";
import { imgSrc, formatPrice, pickLang } from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";

export const PropertyCard = ({ p, large = false }) => {
  const { t, lang } = useLang();
  return (
    <motion.div whileHover={{ y: -6 }} transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}>
      <Link
        to={`/immobili/${p.id}`}
        data-testid={`property-card-${p.id}`}
        className="group block bg-white border border-[#E0E3E6] overflow-hidden hover:shadow-[0_24px_60px_-20px_rgba(16,21,27,0.18)] transition-shadow duration-500"
      >
        <div className={`relative overflow-hidden ${large ? "aspect-[4/3] sm:aspect-[16/10]" : "aspect-[4/3]"}`}>
          <img
            src={imgSrc(p.images?.[0])}
            alt={p.title}
            loading="lazy"
            className="w-full h-full object-cover scale-[1.02] group-hover:scale-110 transition-transform duration-[1.2s] ease-out"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#000000]/50 via-transparent to-transparent opacity-80" />
          {pickLang(p, "badge", lang) && (
            <span className="absolute top-4 left-4 bg-[#000000]/85 backdrop-blur text-[#E8E8E8] text-[11px] font-semibold uppercase tracking-[0.18em] px-3 py-1.5">
              {pickLang(p, "badge", lang)}
            </span>
          )}
          <span className="absolute top-4 right-4 bg-[#FAFAF7]/90 backdrop-blur text-[#000000] text-[11px] font-semibold uppercase tracking-[0.18em] px-3 py-1.5">
            {t(`card.${p.contract}`)}
          </span>
          <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between">
            <span data-testid={`property-price-${p.id}`} className="font-mono-d text-lg sm:text-xl font-semibold text-white drop-shadow">
              {formatPrice(p, lang)}
            </span>
            <span className="font-mono-d text-[11px] text-white/80">{p.ref}</span>
          </div>
        </div>
        <div className="p-5 sm:p-6">
          <h3 className={`font-serif-d font-medium text-[#000000] leading-snug group-hover:text-[#000000] transition-colors ${large ? "text-2xl sm:text-3xl" : "text-xl sm:text-2xl"}`}>
            {pickLang(p, "title", lang)}
          </h3>
          <p className="mt-2 flex items-center gap-1.5 text-sm text-[#5B6670]">
            <MapPin size={14} className="text-[#000000]" /> {p.zone}{p.address ? ` — ${p.address}` : ""}, {p.city || "Roma"}
          </p>
          <div className="mt-4 pt-4 border-t border-[#E0E3E6] flex items-center gap-5 text-sm text-[#5B6670] font-mono-d">
            {p.mq ? <span className="flex items-center gap-1.5"><Maximize2 size={14} className="text-[#000000]" />{p.mq} {t("card.mq")}</span> : null}
            {p.rooms ? <span className="flex items-center gap-1.5"><BedDouble size={14} className="text-[#000000]" />{p.rooms} {t("card.loc")}</span> : null}
            {p.bathrooms ? <span className="flex items-center gap-1.5"><Bath size={14} className="text-[#000000]" />{p.bathrooms} {t("card.bagni")}</span> : null}
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
